<template>
    <div class="admin">
        <form style="margin-bottom:10px;">
            <a-row type="flex" justify="start">
                <a-col :span="10">
                    <a-row :gutter="10">
                        <a-col :span="8">
                            <a-input v-model="keyword" placeholder="搜索产品名称/型号" />
                        </a-col>
                        <a-col :span="6">
                            <a-select v-model="filter_category_id" placeholder="选择分类" allow-clear style="width:100%">
                                <a-select-option v-for="cat in categoryList" :key="cat.id" :value="cat.id">
                                    {{ cat.name }}
                                </a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :span="3">
                            <a-button type="primary" @click="get_data()">搜索</a-button>
                        </a-col>
                    </a-row>
                </a-col>
                <a-col :span="2">
                    <a-button
                        type="primary"
                        @click="openAdd()"
                        v-if="$Func.check_rank('market_add')"
                    >添加产品</a-button>
                </a-col>
            </a-row>
        </form>
        <a-table
            :columns="columns"
            :data-source="tableData"
            @change="change_filter"
            :loading="loading"
            :pagination="page"
            bordered
        >
            <template slot="category_name" slot-scope="text">
                <a-tag color="blue">{{ text }}</a-tag>
            </template>
            <template slot="trend_tpl" slot-scope="text">
                <a-tag v-if="text == 1" color="red">↑ 上涨</a-tag>
                <a-tag v-else-if="text == -1" color="green">↓ 下跌</a-tag>
                <a-tag v-else color="orange">- 持平</a-tag>
            </template>
            <template slot="status_tpl" slot-scope="text">
                <a-tag :color="text == 1 ? 'green' : 'red'">
                    {{ text == 1 ? '启用' : '禁用' }}
                </a-tag>
            </template>
            <template slot="operation" slot-scope="text, record">
                <a @click="() => { update_data(record) }" v-if="$Func.check_rank('market_edit')">编辑</a>
                <a-divider type="vertical" />
                <a @click="() => { delete_data(record) }" v-if="$Func.check_rank('market_del')">删除</a>
            </template>
        </a-table>
        <a-drawer
            title="行情产品"
            :width="650"
            :maskStyle="{ backgroundColor: '#00000010' }"
            :visible="add_model"
            :body-style="{ paddingBottom: '80px' }"
            @close="add_model = false"
        >
            <a-form-model :model="info_add" :rules="add_rules" layout="vertical" @submit="add_data" ref="add_form">
                <a-divider orientation="left">基本信息</a-divider>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item ref="category_id" prop="category_id" label="所属分类">
                            <a-select v-model="info_add.category_id" placeholder="请选择分类">
                                <a-select-option v-for="cat in categoryList" :key="cat.id" :value="cat.id">
                                    {{ cat.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="name" prop="name" label="产品名称">
                            <a-input v-model="info_add.name" placeholder="如：三元锂电池" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item ref="model" label="产品型号">
                            <a-input v-model="info_add.model" placeholder="如：NCM811" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="unit" label="计量单位">
                            <a-input v-model="info_add.unit" placeholder="如：吨、公斤、度" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-divider orientation="left">价格信息</a-divider>
                <a-row :gutter="16">
                    <a-col :span="10">
                        <a-form-model-item ref="avg_price" label="均价（必填）">
                            <a-input-number style="width: 100%" :step="0.01" :precision="2" v-model="info_add.avg_price" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="7">
                        <a-form-model-item label="30天最低价">
                            <a-input style="width:100%;text-align:center;color:#52c41a" :value="info_add.min_price" disabled />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="7">
                        <a-form-model-item label="30天最高价">
                            <a-input style="width:100%;text-align:center;color:#f5222d" :value="info_add.max_price" disabled />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-divider orientation="left">其他信息</a-divider>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item ref="remark" label="备注">
                            <a-textarea v-model="info_add.remark" placeholder="可选备注" :rows="2" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item ref="sort" label="排序">
                            <a-input-number style="width: 100%" :min="0" v-model="info_add.sort" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-model-item label="状态">
                            <a-switch
                                v-model="info_add.status"
                                :checked="info_add.status == 1"
                                :checked-children="'启用'"
                                :un-checked-children="'禁用'"
                                @change="(val) => { info_add.status = val ? 1 : 0 }"
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <div
                    :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1,
                    }"
                >
                    <a-button :style="{ marginRight: '8px' }" @click="add_model = false">取消</a-button>
                    <a-button type="primary" html-type="submit">确定</a-button>
                </div>
            </a-form-model>
        </a-drawer>
    </div>
</template>

<script>
import Func from '../../common/func';

const columns = [
    { title: '#', dataIndex: 'id', key: 'id', width: 60 },
    { title: '分类', dataIndex: 'category_name', key: 'category_name', width: 100, scopedSlots: { customRender: 'category_name' } },
    { title: '产品名称', dataIndex: 'name', key: 'name' },
    { title: '型号', dataIndex: 'model', key: 'model', width: 100 },
    { title: '最低价', dataIndex: 'min_price', key: 'min_price', width: 90 },
    { title: '最高价', dataIndex: 'max_price', key: 'max_price', width: 90 },
    { title: '均价', dataIndex: 'avg_price', key: 'avg_price', width: 90 },
    { title: '趋势', dataIndex: 'trend', key: 'trend', width: 90, scopedSlots: { customRender: 'trend_tpl' } },
    { title: '涨跌幅', dataIndex: 'change_value', key: 'change_value', width: 80 },
    { title: '状态', dataIndex: 'status', key: 'status', width: 70, scopedSlots: { customRender: 'status_tpl' } },
    { title: '更新时间', dataIndex: 'updated_at', key: 'updated_at', width: 160 },
    { title: '操作', dataIndex: 'id', width: 150, key: 'operation', scopedSlots: { customRender: 'operation' } },
];

export default {
    name: 'MarketProduct',
    data() {
        return {
            base_url: Func.api_url,
            columns,
            keyword: '',
            filter_category_id: undefined,
            categoryList: [],
            tableData: [],
            loading: false,
            add_model: false,
            info_add: {
                category_id: undefined,
                name: '',
                model: '',
                unit: '',
                avg_price: 0,
                min_price: 0,
                max_price: 0,
                remark: '',
                sort: 0,
                status: 1,
            },
            add_rules: {
                category_id: [{ required: true, message: '请选择分类', trigger: 'change' }],
                name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
            },
            page: { current: 1, total: 0, pageSize: 10 },
        };
    },
    mounted() {
        this.getCategories();
        this.get_data();
    },
    methods: {
        // 获取分类列表
        getCategories() {
            Func.url_get({ action: 'market.category_all' }, (res) => {
                if (res.error === 0) {
                    this.categoryList = res.info;
                }
            });
        },
        change_filter(pagination) {
            this.get_data(pagination.current);
        },
        get_data(page, tip) {
            if (!page) page = this.page.current || 1;
            if (!tip) this.loading = true;

            Func.url_get(
                {
                    action: 'market.product_list',
                    keyword: this.keyword,
                    category_id: this.filter_category_id || 0,
                    page: page,
                },
                (res) => {
                    if (res.error === 0) {
                        this.tableData = res.info.list;
                        this.page = {
                            pageSize: 10,
                            total: res.info.foot.total,
                            current: parseInt(res.info.foot.current),
                        };
                        this.loading = false;
                    } else {
                        this.$message.error(res.info);
                    }
                }
            );
        },
        openAdd() {
            this.getCategories();
            this.info_add = {
                category_id: this.filter_category_id || undefined,
                name: '',
                model: '',
                unit: '',
                avg_price: 0,
                min_price: 0,
                max_price: 0,
                remark: '',
                sort: 0,
                status: 1,
            };
            this.add_model = true;
        },
        add_data(e) {
            e.preventDefault();
            this.$refs.add_form.validate((valid) => {
                if (valid) {
                    const action = this.info_add.id ? 'market.product_save' : 'market.product_add';
                    Func.url_post({ action, ...this.info_add }, (res) => {
                        if (res.error === 0) {
                            this.$message.success(res.info);
                            this.add_model = false;
                            this.get_data(1, true);
                        } else {
                            this.$message.error(res.info);
                        }
                    });
                }
            });
        },
        update_data(record) {
            const item = JSON.parse(JSON.stringify(record));
            Func.url_get({ action: 'market.product_find', id: item.id }, (res) => {
                // 将字符串价格转为数字
                const info = res.info;
                info.min_price = parseFloat(info.min_price) || 0;
                info.max_price = parseFloat(info.max_price) || 0;
                info.avg_price = parseFloat(info.avg_price) || 0;
                info.sort = parseInt(info.sort) || 0;
                info.status = parseInt(info.status) || 1;
                info.category_id = parseInt(info.category_id);
                this.info_add = info;
                this.getCategories();
                this.add_model = true;
            });
        },
        delete_data(item) {
            if (confirm('确定要删除该产品吗？关联的历史记录也将被删除。') == true) {
                Func.url_get({ action: 'market.product_del', id: item.id }, (res) => {
                    if (res.error === 0) {
                        this.$message.success(res.info);
                        this.get_data(1, true);
                    } else {
                        this.$message.error(res.info);
                    }
                });
            }
        },
    },
};
</script>
